"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductConfig = void 0;
var _ProductContainer = _interopRequireDefault(require("./ProductContainer"));
var _ProductActions = require("./ProductActions");
var _ProductReducer = _interopRequireDefault(require("./ProductReducer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ProductConfig = {
  auth: ['user'],
  routes: [{
    component: _ProductContainer.default,
    path: '/products'
  }],
  reducer: _ProductReducer.default,
  actions: _ProductActions.productsSaga
};
exports.ProductConfig = ProductConfig;